'use client'
import { Button, cn, Image } from "@heroui/react"
import { East } from "@/ui/icons/East"
import Link from "next/link"


export default function NotFound() {
  return (
    <html>
      <body className="flex justify-center">
        <div className={cn(
          "flex flex-1 justify-center items-center gap-0 lg:gap-[100px] mt-[-10vh] lg:mt-[-20vh]",
          "flex-col lg:flex-row",
          "w-full lg:w-auto h-full lg:h-auto"
        )}>
          <Image
            src="/imgs/NotFound.svg"
            classNames={{
              wrapper: "flex-1 w-full",
              img: "h-full lg:h-auto w-full  lg:w-[600px]"
            }}
          />
          <div>
            <h1 className="text-[100px] lg:text-[200px] leading-[1]">
              <span className="gradient-text font-bold ligh">404</span>
            </h1>

            <h2 className="text-[24px] text-theme-primary font-thin italic mt-[40px]">LOOKS LIKE YOU"RE LOST</h2>
            <p className="text-theme-primary/70">Could not find requested resource</p>
            <Button
              href="/"
              className="mt-[40px] font-bold px-0 !bg-transparent text-theme-primary"
              radius="full"
              variant="light"
              as={Link}
              disableRipple
              size="lg">Return Home <East width="24" height="24" /></Button>
          </div>

        </div>
      </body>
    </html>

  )
}